import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  Button,
  ButtonGroup,
  Checkbox,
  FormGroup,
  Modal,
} from 'react-bootstrap';

import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import Dropdown from 'components/v2/dropdowns/DropdownV2';

class CloneShipmentModal extends Component {
  static propTypes = {
    show: PropTypes.bool,
    onClone: PropTypes.func.isRequired,
    onHide: PropTypes.func.isRequired,
  };
  static defaultProps = {
    show: false,
  };
  constructor(props) {
    super(props);
    this.state = {
      accessorials: false,
      documents: false,
      reference_numbers: false,
      tags: false,
      numberOptions: Array.from({ length: 10 }, (_, v) => v + 1),
      shipment_count: 1,
    };
  }
  handleClone = () => {
    const { _numberOptions, ...remainOptions } = this.state;
    this.props.onClone({
      ...remainOptions,
    });
  };
  handleClose = () => {
    this.setState({
      accessorials: false,
      documents: false,
      reference_numbers: false,
      tags: false,
      shipment_count: 1,
    });
    this.props.onHide();
  };
  handleFieldChange = (field) => {
    return () => {
      this.setState((prevState) => {
        const updatedChecked = !prevState[field];
        return { [field]: updatedChecked };
      });
    };
  };
  render() {
    const { show, t } = this.props;
    const {
      accessorials,
      documents,
      reference_numbers,
      tags,
      shipment_count,
      numberOptions,
    } = this.state;

    return (
      <Modal show={show} onHide={this.handleClose} enforceFocus={false}>
        <Modal.Header>
          <Modal.Title>{t('CLONE_SHIPMENT')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormGroup>
            <Checkbox
              onChange={this.handleFieldChange('accessorials')}
              checked={accessorials}
            >
              {t('CLONE_ACCESSORIALS')}
            </Checkbox>
          </FormGroup>
          <FormGroup>
            <Checkbox
              onChange={this.handleFieldChange('documents')}
              checked={documents}
            >
              {t('CLONE_DOCUMENTS')}
            </Checkbox>
          </FormGroup>
          <FormGroup>
            <Checkbox
              onChange={this.handleFieldChange('reference_numbers')}
              checked={reference_numbers}
            >
              {t('CLONE_REFERENCE_NUMBERS')}
            </Checkbox>
          </FormGroup>
          <FormGroup>
            <Checkbox onChange={this.handleFieldChange('tags')} checked={tags}>
              {t('CLONE_TAGS')}
            </Checkbox>
          </FormGroup>
          <FormGroup className="ml-1 flex items-center space-x-2">
            <p>{t('CLONE_MULTIPLE_SHIPMENTS')}</p>
            <Dropdown label={shipment_count}>
              {numberOptions.map((num) => (
                <Dropdown.Button
                  key={num}
                  onClick={() => this.setState({ shipment_count: num })}
                >
                  {num}
                </Dropdown.Button>
              ))}
            </Dropdown>
          </FormGroup>
        </Modal.Body>
        <Modal.Footer>
          <ButtonGroup>
            <Button
              className="shipment-cloneShipmentModal-cloneShipment"
              bsStyle="primary"
              onClick={this.handleClone}
            >
              {titleize(t('CLONE'))}
            </Button>
            <Button onClick={this.handleClose}>{t('CANCEL')}</Button>
          </ButtonGroup>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default withTranslation()(CloneShipmentModal);
